module.exports = __webpack_public_path__ + "static/media/subICloud4.89fe4ac8.png";